/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import { MessageCenter } from 'utils';
const mc = new MessageCenter();


function handleInitialAdjustments({ questionnaire }) {
  return questionnaire.map(question => {
    return question;
  })
}

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
}) {
    let saveFilteredQuestionnaire = false;

    if(question.idQuestion === 1875 && value) {
      const qstDueDate = questionnaireUpdated.find(qst => qst.idQuestion === 1876);
      const qstCompetenceRange = questionnaireUpdated.find(qst => qst.idQuestion === 1878);
      saveFilteredQuestionnaire = true;
      
      if( value.idAnswerOption === 7540){
        qstDueDate.answer = 15;
        qstCompetenceRange.answer = 1;
  
        setFieldValue(qstDueDate.key, 15);
        setFieldValue(qstCompetenceRange.key, 1);
        qstDueDate.behaviorObject.isRequired = true;
        qstCompetenceRange.behaviorObject.isRequired = true;
        } else {
        qstDueDate.answer = '';
        qstCompetenceRange.answer = '';
        setFieldValue(qstDueDate.key, '');
        setFieldValue(qstCompetenceRange.key, '');
        qstDueDate.behaviorObject.isRequired = false;
        qstCompetenceRange.behaviorObject.isRequired = false;
        mc.error('O tomador pode ter emissões efetivadas com este meio de pagamento, os itens serão cobrados no fechamento da respectiva competência');
      }
    }

    if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
  }

const events = {
  handleInitialAdjustments,
  handleQuestionChange
}

export { events };
